const COMPETITION_MARKER_COLORS = [
  '#1976d2',
  '#d32f2f',
  '#2e7d32',
  '#ed6c02',
  '#9c27b0',
  '#00838f',
  '#5d4037',
  '#455a64',
] as const;

export function getCompetitionMarkerColor(competitionId: string, competitionIdsInOrder: string[]): string {
  const index = competitionIdsInOrder.indexOf(competitionId);
  const safeIndex = index >= 0 ? index : 0;
  return COMPETITION_MARKER_COLORS[safeIndex % COMPETITION_MARKER_COLORS.length] ?? COMPETITION_MARKER_COLORS[0];
}

export function competitionIdsFromEditionCompetitions(
  competitions: { id: string }[],
): string[] {
  return competitions.map(c => c.id);
}
